

// 导出excel方法
export default function exportData(dataObj) {


    // dataObj.tHeader 表格头部对应汉字

    // dataObj.tVal   表格每列对应显示字段

    // dataObj.fileName  导出文件名称(非必填，默认为fileName)




    const { export_json_to_excel } = require('@/vendor/Export2Excel');

    let tHeader = dataObj.tHeader;

    let filterVal = dataObj.tVal;

    const list = dataObj.excelData;
    const data = formatJson(filterVal, list);

    let fileName = dataObj.fileName || 'fileName';

    export_json_to_excel(tHeader, data, fileName);
}

function formatJson(filterVal, jsonData) {
    return jsonData.map((v) => filterVal.map((j) => v[j]));
}



// WEBPACK FOOTER //
// ./src/utils/exportTable.js